import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><circle cx="32" cy="32" r="10" /><path d="M32 22v10h5M36 4l-2 6h-4l-2-6M8 28l-4 2v4l6 2m50-8l-4 2v4l6 2M28 60l2-4h4l2 6M16 16l-4-4m40 40l-4-4M52 16l-4-4M16 52l-4-4" /></svg>;